@if (showFooter && user) {
<div class="footer">
  @if (!isKYDBrand) {
  <div class="footer-section">
    <div class="footer-img-container"></div>
  </div>
  } @if (!isKYDBrand) {
  <div class="footer-section">
    <a href="https://www.carnegroup.com/" target="_blank" rel="noopener" class="footer-section">
      <span> ©{{ footerCopyrightDate }} Carne Group </span>
      <span> | </span>
      <span> All Rights Reserved </span>
      <span> | </span>
      <span>{{ buildVersion }}</span>
    </a>
  </div>
  }
  <div class="footer-section">
    @if (isKYDBrand) {
    <a href="http://www.knowyourdistributor.com.au/" target="_blank" rel="noopener"> Know Your Distributor </a>
    } @if (isKYDBrand) { | }
    <a href="{{ TERMS_AND_CONDITIONS_URL }}" target="_blank" rel="noopener">
      {{ "FOOTER.TERMS_OF_USE" | translate }}
    </a>
    |
    <a href="{{ PRIVACY_POLICY_URL }}" target="_blank" rel="noopener">
      {{ "FOOTER.PRIVACY_POLICY" | translate }}
    </a>
    |
    <a routerLink="/help">
      {{ "FOOTER.SUPPORT" | translate }}
    </a>
  </div>
  @if (isKYDBrand) {
  <div class="footer-section">
    <a href="https://www.carnegroup.com/" target="_blank" rel="noopener" class="footer-section">
      <span> ©{{ footerCopyrightDate }} Carne Group </span>
      <span> | </span>
      <span> All Rights Reserved </span>
      <span> | </span>
      <span>{{ buildVersion }}</span>
    </a>
  </div>
  } @if (isKYDBrand) {
  <div class="footer-section">
    <div class="footer-img-container"></div>
  </div>
  }
</div>
}
